import dayjs from 'dayjs';

export default function diffForHumans(date?: Date | string) {
  return dayjs(date)
    .fromNow()
    .replace(/^./, dayjs(date).fromNow()[0].toUpperCase());
}
